(function() {
    'use strict';

    if (window.__NEDiscountDynamicPriceStableV1) return;
    window.__NEDiscountDynamicPriceStableV1 = true;

    var updateTimer = null;
    var updateToken = 0;
    var discountCache = {};
    var observerTimer = null;

    function normalizeCode(code) {
      return String(code || '').trim().toUpperCase();
    }

    function getProductCards() {
      return document.querySelectorAll(
        '.product-item, ' +
        '.product-card, ' +
        '.featured-collection-slider__product[data-product-id], ' +
        '.product-item-slide[data-product-id]'
      );
    }

    function getProductId(card) {
      if (!card) return null;

      var child = card.querySelector('[data-product-id], [data-productId]');

      return (
        card.getAttribute('data-product-id') ||
        card.getAttribute('data-productId') ||
        (
          child &&
          (
            child.getAttribute('data-product-id') ||
            child.getAttribute('data-productId')
          )
        )
      );
    }

    function getPriceElement(card) {
      if (!card) return null;

      return (
        card.querySelector('.product-item__price') ||
        card.querySelector('.product-card__price') ||
        card.querySelector('[data-product-price]') ||
        card.querySelector('.price')
      );
    }

    function parsePrice(priceText) {
      if (!priceText) return null;

      var cleaned = priceText
        .replace(/\s/g, '')
        .replace(/[^\d,.]/g, '');

      if (!cleaned) return null;

      var hasComma = cleaned.indexOf(',') !== -1;
      var hasDot = cleaned.indexOf('.') !== -1;

      if (hasComma && hasDot) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else if (hasComma) {
        cleaned = cleaned.replace(',', '.');
      }

      var price = parseFloat(cleaned);

      return isNaN(price) ? null : price;
    }

    function formatPrice(price) {
      return window.NE.Utils.formatMoney(Math.round(Number(price || 0) * 100));
    }

    function getFromPricePrefix(priceText) {
      return /^\s*ab\b/i.test(String(priceText || '')) ? 'ab ' : '';
    }

    function getActiveDiscountDetails() {
      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.getDetails === 'function'
      ) {
        try {
          var details = window.NE.DiscountTracker.getDetails();

          if (details && details.code) {
            return {
              code: normalizeCode(details.code)
            };
          }
        } catch (e) {}
      }

      try {
        var cached = sessionStorage.getItem('ne_discount_details');

        if (cached) {
          var parsed = JSON.parse(cached);

          if (parsed && parsed.code) {
            return {
              code: normalizeCode(parsed.code)
            };
          }
        }
      } catch (e) {}

      try {
        var storedCode = sessionStorage.getItem('ne_discount_code');

        if (storedCode) {
          return {
            code: normalizeCode(storedCode)
          };
        }
      } catch (e) {}

      var cookieMatch = document.cookie.match(/(?:^|;\s*)ne_discount_code=([^;]+)/);

      if (cookieMatch && cookieMatch[1]) {
        return {
          code: normalizeCode(decodeURIComponent(cookieMatch[1]))
        };
      }

      return null;
    }

    function getOriginalPrice(priceElement) {
      if (!priceElement) return null;

      if (priceElement.hasAttribute('data-original-price')) {
        return parseFloat(priceElement.getAttribute('data-original-price'));
      }

      var originalHtml = priceElement.innerHTML;
      var priceText = priceElement.textContent.trim();
      var originalPrice = parsePrice(priceText);
      var fromPricePrefix = getFromPricePrefix(priceText);

      if (!originalPrice || isNaN(originalPrice)) return null;

      priceElement.setAttribute('data-original-price', originalPrice);
      priceElement.setAttribute('data-original-html', originalHtml);
      priceElement.setAttribute('data-original-price-prefix', fromPricePrefix);

      return originalPrice;
    }

    function restorePriceElement(priceElement, force) {
      if (!priceElement) return;

      /*
        Do not restore during active discount apply.
        This was one of the main causes of flicker.
      */
      if (!force && window.__NEDiscountUiUpdating) return;

      if (priceElement.hasAttribute('data-original-html')) {
        priceElement.innerHTML = priceElement.getAttribute('data-original-html');
        priceElement.removeAttribute('data-original-price');
        priceElement.removeAttribute('data-original-html');
        priceElement.removeAttribute('data-original-price-prefix');
        priceElement.removeAttribute('data-ne-discount-applied');
        priceElement.removeAttribute('data-ne-discount-signature');
      }
    }

    function restoreOriginalPrices(force) {
      document.querySelectorAll('[data-original-html][data-ne-discount-applied]').forEach(function(priceElement) {
        restorePriceElement(priceElement, force);
      });
    }

    function updatePriceElement(priceElement, percentage, code) {
      if (!priceElement || !percentage || percentage <= 0) return;

      var originalPrice = getOriginalPrice(priceElement);

      if (!originalPrice || isNaN(originalPrice)) return;

      var discountedPrice = originalPrice - (originalPrice * percentage / 100);
      var signature = normalizeCode(code) + '|' + originalPrice + '|' + percentage;

      if (
        priceElement.getAttribute('data-ne-discount-signature') === signature &&
        priceElement.getAttribute('data-ne-discount-applied') === 'true'
      ) {
        return;
      }

      var card = priceElement.closest('.product-item, .product-card, .featured-collection-slider__product, .product-item-slide');
      var unitPriceContainer = card ? card.querySelector('[data-unit-price-container]') : null;
      var unitPriceHtml = unitPriceContainer ? unitPriceContainer.outerHTML : '';
      var fromPricePrefix = priceElement.getAttribute('data-original-price-prefix') || '';

      priceElement.innerHTML =
        '<span class="ne-discount-price-wrapper">' +
          '<span class="ne-discount-price__discounted">' + fromPricePrefix + formatPrice(discountedPrice) + '</span>' +
          '<span class="ne-discount-price__original">' + formatPrice(originalPrice) + '</span>' +
        '</span>' +
        unitPriceHtml;

      priceElement.setAttribute('data-ne-discount-applied', 'true');
      priceElement.setAttribute('data-ne-discount-signature', signature);
    }

    function fetchProductDiscount(code, productId) {
      code = normalizeCode(code);
      productId = String(productId || '').trim();

      if (!code || !productId) return Promise.resolve(0);

      var cacheKey = code + ':' + productId;

      if (Object.prototype.hasOwnProperty.call(discountCache, cacheKey)) {
        return Promise.resolve(discountCache[cacheKey]);
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.fetchProductDiscount === 'function'
      ) {
        return window.NE.DiscountTracker.fetchProductDiscount(code, productId)
          .then(function(percentage) {
            percentage = Number(percentage || 0);
            discountCache[cacheKey] = percentage;
            return percentage;
          })
          .catch(function() {
            discountCache[cacheKey] = 0;
            return 0;
          });
      }

      return Promise.resolve(0);
    }

    function updateProductPrices() {
      updateToken += 1;

      var token = updateToken;
      var details = getActiveDiscountDetails();

      if (!details || !details.code) {
        restoreOriginalPrices(true);
        return;
      }

      var processedPriceElements = [];

      getProductCards().forEach(function(card) {
        var productId = getProductId(card);
        if (!productId) return;

        var priceElement = getPriceElement(card);
        if (!priceElement) return;

        if (processedPriceElements.indexOf(priceElement) !== -1) return;
        processedPriceElements.push(priceElement);

        fetchProductDiscount(details.code, productId).then(function(percentage) {
          if (token !== updateToken) return;

          percentage = Number(percentage || 0);

          if (percentage > 0) {
            updatePriceElement(priceElement, percentage, details.code);
          } else {
            restorePriceElement(priceElement, false);
          }
        });
      });
    }

    function scheduleUpdate(delay, clearCache) {
      if (clearCache) {
        discountCache = {};
      }

      window.__NEDiscountUiUpdating = true;

      clearTimeout(updateTimer);

      updateTimer = setTimeout(function() {
        requestAnimationFrame(function() {
          updateProductPrices();

          setTimeout(function() {
            window.__NEDiscountUiUpdating = false;
          }, 500);
        });
      }, typeof delay === 'number' ? delay : 180);
    }

    function initMutationObserver() {
      var observer = new MutationObserver(function(mutations) {
        var shouldUpdate = false;

        mutations.forEach(function(mutation) {
          if (!mutation.addedNodes || !mutation.addedNodes.length) return;

          mutation.addedNodes.forEach(function(node) {
            if (!node || node.nodeType !== 1) return;

            if (
              node.matches &&
              (
                node.matches('.product-item') ||
                node.matches('.product-card') ||
                node.matches('.featured-collection-slider__product') ||
                node.matches('.product-item-slide')
              )
            ) {
              shouldUpdate = true;
            }

            if (
              node.querySelector &&
              node.querySelector('.product-item, .product-card, .featured-collection-slider__product, .product-item-slide')
            ) {
              shouldUpdate = true;
            }
          });
        });

        if (!shouldUpdate) return;

        clearTimeout(observerTimer);

        observerTimer = setTimeout(function() {
          scheduleUpdate(160, false);
        }, 250);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    function init() {
      scheduleUpdate(250, false);

      window.addEventListener('ne:discount-code-updated', function() {
        scheduleUpdate(280, true);
      });

      window.addEventListener('ne:discount-details-updated', function() {
        scheduleUpdate(280, true);
      });

      document.addEventListener('discount:updated', function() {
        scheduleUpdate(280, true);
      });

      window.addEventListener('ne:discount-code-cleared', function() {
        discountCache = {};
        restoreOriginalPrices(true);
      });

      document.addEventListener('theme:pagination:loaded', function() {
        scheduleUpdate(250, false);
      });

      document.addEventListener('shopify:section:load', function() {
        scheduleUpdate(250, false);
      });

      window.addEventListener('load', function() {
        scheduleUpdate(400, false);
      });

      initMutationObserver();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
      })();
